'use client'
import dynamic from 'next/dynamic'
import React, { memo } from 'react'
import { Skeleton } from '@mantine/core'

export const NewBookingFormMobile = dynamic(
  () => import('../section/NewBookingFrom'),
  {
    ssr: false,
    loading: () => {
      return <Skeleton h={320} w={'100%'} radius={12} bdrs={10} />
    },
  },
)

type PropertyDetailsData = {
  data?: unknown
} | null | undefined

type Props = {
  id: string
  data: PropertyDetailsData
  loading: boolean
  initialGuests?: number
  initialCheckin?: string
  initialCheckout?: string
  showGuestsDropdown: boolean
  setShowGuestsDropdown: React.Dispatch<React.SetStateAction<boolean>>
}

const MobileBookingForm = ({
  id,
  data,
  loading,
  initialGuests,
  initialCheckin,
  initialCheckout,
  showGuestsDropdown,
  setShowGuestsDropdown,
}: Props) => {
  return (
    <>
      <div className='relative w-full p-3 mx-auto overflow-visible'>
        {loading || !data ? (
          <Skeleton h={320} w={'100%'} radius={12} bdrs={10} />
        ) : (
          <NewBookingFormMobile
            propertyId={id}
            data={data?.data}
            initialGuests={initialGuests}
            initialCheckin={initialCheckin}
            initialCheckout={initialCheckout}
            showGuestsDropdown={showGuestsDropdown}
            setShowGuestsDropdown={setShowGuestsDropdown}
          />
        )}
      </div>
    </>
  )
}

export default memo(MobileBookingForm)
